import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import * as i18n from "../common/i18n";
import MaterialTable from 'material-table'
import { reactLocalStorage } from 'reactjs-localstorage';

import gql from 'graphql-tag';
import Message from "./Message";
import * as graphql from '../common/graphql';
import * as helper from "../common/helper";
import moment from "moment";
import Chip from '@material-ui/core/Chip';
import RouterIcon from '@material-ui/icons/Router';
import ReloadIcon from '@material-ui/icons/Replay';
import { EventCode, suggestedEventCodes } from "../common/constants";

import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";

const styles = theme => ({
});


const defaults = {
    id: true,
    device: false,
    code: false,
    created: false,
    pageSize: 20,
};

const defaultsPropertyName = 'p71.events.defaults';

class Events extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            userSettings: reactLocalStorage.getObject(defaultsPropertyName, defaults),
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(defaultsPropertyName, newUserSettings);
        });
    }


    getEventSuggestions = async (value) => {
        const codes = suggestedEventCodes.filter(e => {
            const regExp = new RegExp(value, 'i');
            return e["name"].match(regExp)
        });
        return codes
    }

    getDefaultSuggestions = () => {
        return [];
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    mapField(column) {
        switch (column) {
            case "device":
                return "uuid"
            default:
                return column;
        }
    }

    render() {

        return (
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization()}
                    columns={[
                        {
                            title: i18n.get("events.id"),
                            field: 'id',
                            hidden: this.default("id"),
                            sorting: false,
                            filtering: false
                        },
                        {
                            title: i18n.get("events.device"),
                            field: 'device',
                            hidden: this.default("device"),
                            sorting: true,
                            filtering: true,
                            render: rowData => {
                                return rowData && rowData.device ? <Chip label={rowData.device.uuid} icon={<RouterIcon />} /> : null
                            }
                        },
                        {
                            title: i18n.get("events.code"),
                            field: 'code',
                            hidden: this.default("code"),
                            sorting: false,
                            filtering: true,
                            lookup: EventCode,
                            filterComponent: helper.chipsFilter(
                                (items, props) =>
                                    props.onFilterChanged(
                                        props.columnDef.tableData.id,
                                        items.map((item) => `${item.value}`)
                                    ),
                                (value) =>
                                    value.map((v) => {
                                        return {
                                            name: `${v.code}`,
                                            value: v.id,
                                        };
                                    }),
                                this.getEventSuggestions,
                                this.getDefaultSuggestions
                            ),
                            render: rowData => {
                                if (rowData) {
                                    return helper.eventChipOf(rowData.code, rowData.id);
                                } else {
                                    return null
                                }
                            }
                        },
                        {
                            title: i18n.get("events.created"),
                            field: 'created',
                            hidden: this.default("created"),
                            type: "datetime",
                            cellStyle: {
                                width: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                width: '400px',
                                maxWidth: '400px',
                            },
                            filterComponent: helper.DateRangeFilter,
                            sorting: true,
                            filtering: true
                        }

                    ]}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {

                                const where = helper.whereString(query["filters"], this.mapField, ["uuid"]);
                                const orderBy = helper.orderByString(query, this.mapField, "created", query["orderBy"] && query["orderBy"]["field"] === "device")

                                if (query["orderBy"] && query["orderBy"]["field"] === "device" && where === "[]") {
                                    where = '[{column: "created", comparator: GT, datetime: -1}]'
                                }

                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        events(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                                ... on Event {
                                                    id,
                                                    device {uuid}
                                                    code
                                                    created {isoString}
                                               }
                                            }
                                        }
                                    }
                                `,
                                    fetchPolicy: "no-cache"
                                });

                                const searchResult = {
                                    page: query.page,
                                    data: result.data.events.elements.map(
                                        (element) => {
                                            return {
                                                id: element.id,
                                                device: element.device,
                                                code: element.code,
                                                created: element.created ? moment(element.created.isoString).toDate() : null,
                                            };
                                        }),
                                    totalCount: result.data.events.totalCount
                                }

                                resolve(searchResult);
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }
                    actions={[{
                        isFreeAction: true,
                        icon: () => { return <ReloadIcon /> },
                        tooltip: i18n.get("general.reload"),
                        onClick: async (event, rowData) => {
                            this.tableRef.current.onQueryChange();
                        }
                    }]}
                    title={i18n.get("events.title")}
                    options={{
                        addRowPosition: "first",
                        exportButton: false,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 500,
                        search: false,
                        columnsButton: true,
                        pageSize: this.default("pageSize"),
                        pageSizeOptions: [5, 20, 50]
                    }}
                />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />
            </div>
        )
    }
}

Events.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(Events))